import { Box, Text } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';

import { CenterReportGathering } from '@/module/Laboratory/CenterReportGathering';
import { getCenterLastReportOptions } from '@/module/ResearchCenter';

import { Id } from '@feature/utils';

export function CenterReport({ labId }: { labId: Id }) {
  const { data } = useSuspenseQuery(getCenterLastReportOptions());

  return (
    <Box>
      {data.open && <CenterReportGathering labId={labId} />}
      {!data.open && <Text fs="italic">Nu se mai pot introduce date</Text>}
    </Box>
  );
}
